/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {
  getBookingService,
  getListBookingExcelService,
  getTemplateCheckinPrintingService,
} from '../../../../services/booking.service'
import {BookingModel} from '../../../../models/booking.model'
import moment from 'moment'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {CampModel, ClientModel, CompanyModel, SiteModel} from '../../../../../central/model'
import {getCamp, getClient, getCompany, getSite} from '../../../../../central/services'
import {getMasterModuleService} from '../../../modules/services'
import {SelectOption} from '../../../../../../models/utility.model'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const TableBookings: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
    selected,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useHoteleria()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [companyType, setCompanyType] = useState<SelectOption[]>([])
  const [statusType, setStatusType] = useState<SelectOption[]>([])
  const [chargeType, setChargeType] = useState<SelectOption[]>([])
  const [selectedItem, setSelectedItem] = useState(null)
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false)

  //

  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.nombreEmpresa,
    }))
    setCompany(mappedSites)
  }

  const getClientList = async () => {
    //await new Promise(resolve => setTimeout(resolve, 2000));
    let obj: ClientModel = {
      isCombo: true,
    }
    const response = await getClient(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setClient(mappedSites)
  }

  const getSiteList = async () => {
    let obj: SiteModel = {
      isCombo: true,
    }
    const response = await getSite(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }
  const getCampList = async () => {
    let obj: CampModel = {
      isCombo: true,
    }
    const response = await getCamp(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setCamp(mappedSites)
  }

  const getCompanyTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoEmpresa',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setCompanyType(mappedModuleTypes)
    } catch (error) {
      setCompanyType([])
    }
  }

  const getStatusTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoReservaHuesped',
      })
      const data = response.data.data
      const filterData = data.filter((item) => item.codigo !== '8' && item.codigo !== '5')
      const mappedModuleTypes = filterData?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setStatusType(mappedModuleTypes)
    } catch (error) {
      setStatusType([])
    }
  }

  const getChargeTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoCargaReserva',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setChargeType(mappedModuleTypes)
    } catch (error) {
      setChargeType([])
    }
  }

  //

  const getBookings = async () => {
    try {
      const obj: TabModel = {
        ...currentTabItem,
        loadingTable: false,
        fromDetailPanel: false,
      }
      changeCurrentTabItem(obj)
      setLoading(true)
      // changeSearchValues({})
      const {data: response} = await getBookingService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleShowDetail = (item: BookingModel) => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      noFormDetail: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'detail-bookings',
      },
      idToDelete: '',
      idToEdit: item.Id,
      objectInfo: item,
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    const findId = data.find(
      (item) => item.Id === id && item.TipoCargaReserva_descripcion === 'CARGA CHECKIN IMPRESION',
    )
    setSelectedItem(findId)
    let idChange = id === currentTabItem.idToDelete ? '' : id
    if (idChange && findId) {
      setSelectedItem(findId)
    } else {
      setSelectedItem(null)
    }
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  useEffect(() => {
    getBookings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  // const handleFilterClient = (e: any, name: string) => {
  //   let value = e.value
  //   getClientList(value)
  //   const {ClienteId, SiteId, CampamentoId, ...valuesSearch} = searchValues
  //   const nuevoObjeto = {...valuesSearch, [name]: value}
  //   changeSearchValues(nuevoObjeto)
  // }

  // const handleFilterSite = (e: any, name: string) => {
  //   let value = e.value
  //   getSiteList(value)
  //   const {SiteId, CampamentoId, ...valuesSearch} = searchValues
  //   const nuevoObjeto = {...valuesSearch, [name]: value}
  //   changeSearchValues(nuevoObjeto)
  // }

  // const handleFilterCamp = (e: any, name: string) => {
  //   let value = e.value
  //   getCampList(value)
  //   const {CampamentoId, ...valuesSearch} = searchValues
  //   const nuevoObjeto = {...valuesSearch, [name]: value}
  //   changeSearchValues(nuevoObjeto)
  // }

  //

  const columns: Column<BookingModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) =>
          isAllowed('VER') ? (
            <div
              className='d-flex justify-content-left flex-shrink-0'
              onClick={() => handleShowDetail(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='CampamentoId'
            selecteable
            data={camp}
          />
        ),
        accessor: 'Campamento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de Reserva'
            name='NroReserva'
            searcheable
            numberGuion
          />
        ),
        accessor: 'NroReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='EstadoReservaId'
            selecteable
            data={statusType}
          />
        ),
        accessor: 'EstadoReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Carga'
            name='TipoCargaReservaId'
            selecteable
            data={chargeType}
          />
        ),
        accessor: 'TipoCargaReserva_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Inicio' name='FechaInicio' dateable />
        ),
        accessor: 'FechaInicio',
        // Cell: ({...props}) => (
        //   <div>{moment(props.row.original.FechaInicio).format('DD/MM/YYYY')}</div>
        // ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin' name='FechaFin' dateable />
        ),
        accessor: 'FechaFin',
        // Cell: ({...props}) => <div>{moment(props.row.original.FechaFin).format('DD/MM/YYYY')}</div>,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de Camas'
            name='NroCamas'
            searcheable
            number
          />
        ),
        accessor: 'NroCamas',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name='CompaniaId'
            selecteable
            data={compani}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={site} />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions_ver',
        Cell: ({...props}) =>
          isAllowed('VER') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleShowDetail(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [compani, client, camp, site, statusType, chargeType, selectedOn],
  )

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      getBookings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    if (currentTabItem.loadingTable && currentTabItem.fromDetailPanel) {
      clearSelected()
      getBookings()
    }
  }, [currentTabItem.loadingTable])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      if (pagination.currentPage === 1) {
        getBookings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getBookings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()
    getCompanyTypes()
    getStatusTypes()
    getChargeTypes()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getBookings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  const handlePrint = async () => {
    if (!selectedItem) return
    setLoadingPrint(true)
    const bookingId = selectedItem.Id
    try {
      //   setLoadingDownload(true)
      const response = (await getTemplateCheckinPrintingService(bookingId)) as any
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Checkin-Impresion.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      //   setLoadingDownload(false)
    } catch (error) {
      getSnackBarToast('Hubo un error al descargar', 'error')
    } finally {
      setLoadingPrint(false)
    }
  }

  const handleExport = async () => {
    try {
      const response = await getListBookingExcelService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Reservas-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }

  return (
    <>
      {isAllowed('BUSCAR') && (
        <KTCard shadow className='m-5'>
          <ButtonWrapper className={'sdx-white-bg'}>
            <Button label='Exportar' onClick={handleExport} disabled={data.length < 1} />
            <Button
              label='Re Imprimir Checkin'
              onClick={handlePrint}
              disabled={!selectedItem || loadingPrint}
              loading={loadingPrint}
            />
          </ButtonWrapper>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableBookingsWrapper = () => {
  return (
    <KTableProvider>
      <TableBookings />
    </KTableProvider>
  )
}

export {TableBookingsWrapper}
